import { HomeIcon } from '@heroicons/react/24/outline'
import { Fragment, useEffect, useState } from 'react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DatagridResumen({ data }) {

  //Controlador del filtro
  const [filter, setFilter] = useState({
    Active: false,
    Inactive: false,
    All: true
  })
  const handleFilter = (FILTER_FLAG) => {
    //filterData(data, FILTER_FLAG)

    switch (FILTER_FLAG) {
      case 'ACTIVE':
        setFilter({ Active: true, Inactive: false, All: false })
        break;
      case 'INACTIVE':
        setFilter({ Active: false, Inactive: true, All: false })
        break;
      default:
        setFilter({ Active: false, Inactive: false, All: true })
        break;
    }
  }

  const getFilterKey = () => {
    const [filterSelected] = Object.entries(filter).filter(([, value]) => value)
    return filterSelected[0]
  }

  const selectedFilter = getFilterKey()
    
  return (
    <div className="p-5 bg-primarioMira rounded-lg shadow-xl">
      <div className="sm:flex sm:items-center">
        <HomeIcon
          className='h-14 w-14 mr-2 text-secundario'
        />
        <div className="sm:flex-auto">
          <div className='flex flex-row'>
            <div>
              <h1 className="text-lg font-semibold text-white">Reporte de descuento reducido - Por Sede</h1>
            </div>
          </div>
          <p className="mt-2 text-sm text-grisMira">
            Lista de totales de descuento reducido por sede.
          </p>
        </div>

        <div className='flex gap-5'>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Activos</label>
            <input
              type='radio'
              checked={filter.Active}
              onChange={() => handleFilter('ACTIVE')}
              className='text-azulLogo'
            />
          </div>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Inactivos</label>
            <input
              type='radio'
              checked={filter.Inactive}
              onChange={() => handleFilter('INACTIVE')}
              className='text-azulLogo'
            />
          </div>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Todos</label>
            <input
              type='radio'
              checked={filter.All}
              onChange={handleFilter}
              className='text-azulLogo'
            />
          </div>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full">
              <thead className="bg-secundarioMira">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Ciclo
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Sede
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-right text-sm font-semibold text-grisMira">
                    Total de alumnos
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-right text-sm font-semibold text-grisMira">
                    Total de descuento reducido
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-grisMira sm:pl-3">
                    Total de saldo
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-right text-sm font-semibold text-grisMira">
                    Total de saldo a pagar
                  </th>
                </tr>
              </thead>
              <tbody className="bg-primarioMira">
                {data?.map((sede, sedeIdx) => (
                  <tr
                    key={sedeIdx}
                    className={classNames(sedeIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t hover:bg-secundarioMira transition-all duration-200 ease-in')}
                  >
                    <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{sede.Ciclo}</td>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-white sm:pl-3">{sede.NombreSede}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                      {selectedFilter === 'All'
                        ? sede.TotalAlumnos
                        : (selectedFilter === 'Active')
                          ? sede.TotalAlumnosActivos
                          : (selectedFilter === 'Inactive')
                            ? sede.TotalAlumnosInactivos
                            : null}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                      {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                        selectedFilter === 'All'
                          ? sede.TotalMora
                          : (selectedFilter === 'Active')
                            ? sede.TotalMoraActivos
                            : (selectedFilter === 'Inactive')
                              ? sede.TotalMoraInactivos
                              : null)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                      {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                        selectedFilter === 'All'
                          ? sede.TotalSaldo
                          : (selectedFilter === 'Active')
                            ? sede.TotalSaldoActivos
                            : (selectedFilter === 'Inactive')
                              ? sede.TotalSaldoInactivos
                              : null)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                      {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                        selectedFilter === 'All'
                          ? sede.TotalSaldoPagar
                          : (selectedFilter === 'Active')
                            ? sede.TotalSaldoPagarActivos
                            : (selectedFilter === 'Inactive')
                              ? sede.TotalSaldoPagarInactivos
                              : null)}
                    </td>
                  </tr>
                ))}
                {(data !== undefined && data !== null) ?
                  data.length >= 2 ?
                    data?.map((sede, sedeIdx) => (
                      sedeIdx === 0 ?
                        <tr
                          key={sedeIdx}
                          className={classNames('border-gray-300 border-t hover:bg-secundarioMira transition-all duration-200 ease-in')}
                        >
                          <>
                            <th
                              colSpan={1}
                              scope="colgroup"
                            >
                            </th>
                            <th scope="row" className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                              Totales
                            </th>
                            <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                              {
                                selectedFilter === 'All'
                                  ? sede.TotalGralAlumnos
                                  : (selectedFilter === 'Active')
                                    ? sede.TotalGralAlumnosActivos
                                    : (selectedFilter === 'Inactive')
                                      ? sede.TotalGralAlumnosInactivos
                                      : null
                              }
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? sede.TotalGralMora
                                  : (selectedFilter === 'Active')
                                    ? sede.TotalGralMoraActivos
                                    : (selectedFilter === 'Inactive')
                                      ? sede.TotalGralMoraInactivos
                                      : null)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? sede.TotalGralSaldo
                                  : (selectedFilter === 'Active')
                                    ? sede.TotalGralSaldoActivos
                                    : (selectedFilter === 'Inactive')
                                      ? sede.TotalGralSaldoInactivos
                                      : null)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white text-right">
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? sede.TotalGralSaldoPagar
                                  : (selectedFilter === 'Active')
                                    ? sede.TotalGralSaldoPagarActivos
                                    : (selectedFilter === 'Inactive')
                                      ? sede.TotalGralSaldoPagarInactivos
                                      : null)}
                            </td>
                          </>
                        </tr>
                        : null
                    ))
                    : null
                  : null
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}